var map = {
	".": 34,
	"./": 34,
	"./Chasis.webp": 268,
	"./Color.webp": 269,
	"./Groupgg.png": 270,
	"./Motor.webp": 271,
	"./Placa.webp": 272,
	"./arrow-right.png": 273,
	"./icono1.svg": 274,
	"./icono1gris.svg": 535,
	"./icono2.svg": 536,
	"./icono2gris.svg": 537,
	"./icono3.svg": 538,
	"./icono3gris.svg": 539,
	"./icono4.svg": 275,
	"./icono5.svg": 276,
	"./icono6.svg": 277,
	"./icono7.svg": 278,
	"./index": 34,
	"./index.js": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 534;